import DesktopVehicleView from './DesktopVehicleView';
export default DesktopVehicleView;
